/* eslint-disable */
import { NgModule, SkipSelf, Optional } from '@angular/core';

import { InstantsearchService } from './services/instantsearch.service';
import { TimetableService } from './services/timetable.service';

/**
 * Module that provides all services.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    InstantsearchService,
    TimetableService,
  ],
})
export class InstantsearchApiModule {
  constructor(
    @Optional() @SkipSelf() parentModule: InstantsearchApiModule
  ) {
    if (parentModule) {
      throw new Error('InstantsearchApiModule is already loaded. Import in your base AppModule only.');
    }
  }
}
